import { useEffect, useState } from 'react';

/** useHasChangedSince says whether `value` has changed since `from` was first set; a new `from` starts again. */
export const useHasChangedSince = <T>(
  value: T,
  from: string | undefined,
): boolean => {
  const [seen, setSeen] = useState<{ from: string; value: T }>();

  useEffect(() => {
    if (from && seen?.from !== from) setSeen({ from, value });
  }, [from, seen?.from, value]);

  return !!from && seen?.from === from && seen.value !== value;
};
